import React from 'react';
import VExportPaymentBaseItem from '../../../../Domain/VExportPaymentBaseItem';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import FigmaPopup from '../../../../Elements/figmaPopup';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import PopupTypesEnum from '../../../../Enums/PopupTypesEnum';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import ReconcileParamsItem from '../../../../Domain/ReconcileParamsItem';
import VExportPaymentService from '../../../../Services/VExportPaymentService';
import VoidAndReissueParamsItem from '../../../../Domain/VoidAndReissueParamsItem';
import ExportPaymentSearchParams from './ExportPaymentSearchParams';
import ReconcileWindowDescription from './ReconcileWindowDescription';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import VoidAndReissueWindowDescription from './VoidAndReissueWindowDescription';
import VoidAndSuppressWindowDescription from './VoidAndSuppressWindowDescription';
import VoidWindowDescription from './VoidWindowDescription';
import PaymentInformationValidationWindowDescription from './PaymentInformationValidationWindowDescription';
import PaymentInformationValidationItem from './PaymentInformationValidationItem';
import RequestPaymentDetailsReviewWindowDescription from './RequestPaymentDetailsReviewWindowDescription';
import RequestPaymentDetailsReviewItem from './RequestPaymentDetailsReviewItem';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';

export default class PaymentExportDetailsPaymentExportsTab extends React.Component {
  static defaultProps = {
    showActionButtonRow: true,
  };

  constructor(props) {
    super(props);

    const newSearchItem = new ExportPaymentSearchParams();

    if (props.evaluatorId) {
      newSearchItem.EvaluatorId = props.evaluatorId;
    }
    if (props.ieStatusCode) {
      newSearchItem.IeStatusCode = props.ieStatusCode;
    }

    this.state = {
      searchItem: newSearchItem,
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      popup: null,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    VExportPaymentBaseItem.clickOnSelect = this.clickOnSelect.bind(this);
    this.changeOfItemListFunction = this.changeOfItemListFunction.bind(this);
    this.clickOnVoidButton = this.clickOnVoidButton.bind(this);
    this.clickOnVoidAndReissueButton = this.clickOnVoidAndReissueButton.bind(this);
    this.clickOnVoidAndSuppressButton = this.clickOnVoidAndSuppressButton.bind(this);
    this.clickOnResendEvaluatorStatementButton = this.clickOnResendEvaluatorStatementButton.bind(this);
    this.clickOnResendEvaluatorStatementButtonInPopup = this.clickOnResendEvaluatorStatementButtonInPopup.bind(this);
    VExportPaymentBaseItem.reconcileFunction = this.clickOnReconcileButtonInActionsMenu.bind(this);
    VExportPaymentBaseItem.voidFunction = this.clickOnVoidButtonInActionsMenu.bind(this);
    VExportPaymentBaseItem.voidAndReissueFunction = this.clickOnVoidAndReissueButtonInActionsMenu.bind(this);
    VExportPaymentBaseItem.voidAndSuppressFunction = this.clickOnVoidAndSupressButtonInActionsMenu.bind(this);
    VExportPaymentBaseItem.resendEvaluatorStatementFunction =
      this.clickOnResendEvaluatorStatementButtonInActionsMenu.bind(this);
  }

  componentDidMount() {}

  changeOfItemListFunction(itemList) {
    this.setState({ itemList });
  }

  startSearch(searchItem) {
    this.setState({
      searchItem: { ...searchItem },
    });
  }

  clickOnSelect(item, selected) {
    item.Selected = !item.Selected;
    this.setState({ itemList: [...this.state.itemList] });
  }

  getSelectedIds() {
    const selected = this.state.itemList.filter((item) => item.Selected === true);
    return selected.map((item) => item.ExportPaymentId);
  }

  getSelectedIdsInReconciledStatus() {
    const selected = this.state.itemList.filter(
      (item) => item.Selected === true && item.StatusCodeName === 'Reconciled'
    );
    return selected.map((item) => item.ExportPaymentId);
  }

  clickOnVoidButton() {
    const paramsData = new VoidAndReissueParamsItem({
      ids: this.getSelectedIds(),
      reason: '',
      surcharge: 0,
    });
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={paramsData}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={VoidWindowDescription}
        errorCode='PEDPET102'
      />
    );
    this.setState({ popup });
  }

  clickOnVoidAndReissueButton() {
    const paramsData = new VoidAndReissueParamsItem({
      ids: this.getSelectedIds(),
      reason: '',
      surcharge: 0,
    });
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={paramsData}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={VoidAndReissueWindowDescription}
        errorCode='PEDPET121'
      />
    );
    this.setState({ popup });
  }

  clickOnVoidAndSuppressButton() {
    const paramsData = new VoidAndReissueParamsItem({
      ids: this.getSelectedIds(),
      reason: '',
      surcharge: 0,
    });
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={paramsData}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={VoidAndSuppressWindowDescription}
        errorCode='PEDPET140'
      />
    );
    this.setState({ popup });
  }

  clickOnReconcileButtonInActionsMenu(exportId, item) {
    const paramsData = new ReconcileParamsItem(item);

    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={paramsData}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={ReconcileWindowDescription}
        errorCode='PEDPET156'
      />
    );
    this.setState({ popup });
  }

  clickOnResendEvaluatorStatementButton(selected) {
    if (selected.length === 0) ErrorMessage.SetWarning('There is no reconciliated payment export selected.');
    else {
      const text =
        selected.length === 1
          ? `The evaluator statement of the payment export #${selected[0]} will be sent again.`
          : `The evaluator statements of the selected and reconciled payment exports (${selected.length} pcs) will be sent again.`;
      this.setState({
        popup: (
          <FigmaPopup
            type={PopupTypesEnum.Approve}
            text={text}
            okPopupFunction={() => {
              this.setState({ popup: null });
              this.clickOnResendEvaluatorStatementButtonInPopup(selected);
            }}
            closePopupFunction={() => this.setState({ popup: null })}
          />
        ),
      });
    }
  }

  clickOnResendEvaluatorStatementButtonInPopup(selected) {
    VExportPaymentService.ResendEvaluatorStatement(selected).catch(() => ErrorMessage.SetErrorMessage('PEDPET183'));
  }

  clickOnVoidButtonInActionsMenu(exportId, item) {
    const paramsData = new VoidAndReissueParamsItem({
      ids: [exportId],
      reason: '',
      surcharge: 0,
    });
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={paramsData}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={VoidWindowDescription}
        errorCode='PEDPET202'
      />
    );
    this.setState({ popup });
  }

  clickOnVoidAndReissueButtonInActionsMenu(exportId, item) {
    const paramsData = new VoidAndReissueParamsItem({
      ids: [exportId],
      reason: '',
      surcharge: 0,
    });
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={paramsData}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={VoidAndReissueWindowDescription}
        errorCode='PEDPET221'
      />
    );
    this.setState({ popup });
  }

  clickOnVoidAndSupressButtonInActionsMenu(exportId, item) {
    const paramsData = new VoidAndReissueParamsItem({
      ids: [exportId],
      reason: '',
      surcharge: 0,
    });
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={paramsData}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={VoidAndSuppressWindowDescription}
        errorCode='PEDPET240'
      />
    );
    this.setState({ popup });
  }

  clickOnResendEvaluatorStatementButtonInActionsMenu(exportId, item) {
    this.clickOnResendEvaluatorStatementButton([exportId]);
  }

  clickOnValidatePaymentInformation() {
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={new PaymentInformationValidationItem({ exportId: this.props.exportId })}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={PaymentInformationValidationWindowDescription}
        errorCode='PEDPET_PIV'
      />
    );
    this.setState({ popup });
  }

  clickOnRequestPaymentDetailsReview() {
    const popup = (
      <GeneralEditWizzardBase
        crudType={CrudTypesEnum.Update}
        editedItem={new RequestPaymentDetailsReviewItem({ exportId: this.props.exportId })}
        clickOnCancel={() => this.setState({ popup: null })}
        clickOnSave={() => this.setState({ popup: null })}
        windowDescription={RequestPaymentDetailsReviewWindowDescription}
        errorCode='PEDPET_RPDR'
      />
    );
    this.setState({ popup });
  }

  showPanel(shownPanel) {
    const paramsData = new VoidAndReissueParamsItem({
      ids: this.getSelectedIds(),
      reason: '',
      surcharge: 0,
    });

    if (shownPanel === ShownPanelsEnum.Void) {
      this.setState({
        popup: (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={paramsData}
            clickOnCancel={() => this.setState({ popup: null })}
            clickOnSave={() => this.setState({ popup: null })}
            windowDescription={VoidWindowDescription}
            errorCode='PEDPET266'
          />
        ),
      });
    } else if (shownPanel === ShownPanelsEnum.VoidAndReissue) {
      this.setState({
        popup: (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={paramsData}
            clickOnCancel={() => this.setState({ popup: null })}
            clickOnSave={() => this.setState({ popup: null })}
            windowDescription={VoidAndSuppressWindowDescription}
            errorCode='PEDPET279'
          />
        ),
      });
    } else if (shownPanel === ShownPanelsEnum.VoidAndSuppress) {
      this.setState({
        popup: (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={paramsData}
            clickOnCancel={() => this.setState({ popup: null })}
            clickOnSave={() => this.setState({ popup: null })}
            windowDescription={VoidAndSuppressWindowDescription}
            errorCode='PEDPET292'
          />
        ),
      });
    } else if (shownPanel === ShownPanelsEnum.ResendStatement) {
      this.clickOnResendEvaluatorStatementButtonInPopup(this.getSelectedIdsInReconciledStatus());
    }
  }

  renderActionButtonRow() {
    const disabled = !this.state.itemList.find((il) => il.Selected);

    const buttons = [
      {
        iconName: 'fa-regular fa-xmark',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Primary,
        iconPosition: IconPositionEnum.Center,
        onClick: this.clickOnVoidButton.bind(this),
        tooltip: 'Void',
        roleKey: 'ExportPayment_FigmaButtonRowButton',
        disabled,
      },
      {
        iconName: 'fa-solid fa-rotate-right',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: this.clickOnVoidAndReissueButton,
        tooltip: 'Void & Reissue',
        roleKey: 'ExportPayment_FigmaButtonRowButton',
        disabled,
      },
      {
        iconName: 'fa-solid fa-trash',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: this.clickOnVoidAndSuppressButton,
        roleKey: 'ExportPayment_FigmaButtonRowButton',
        tooltip: 'Void & Suppress',
        disabled,
      },
      {
        iconName: 'fa-solid fa-envelope',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: () => this.clickOnResendEvaluatorStatementButton(this.getSelectedIdsInReconciledStatus()),
        tooltip: 'Resend Statement',
        roleKey: 'EvaluatorPayment_ResendStatement_FigmaButtonRowButton',
        disabled,
      },
    ];

    // Export-level upload actions only make sense when viewing a single Export's payments.
    if (this.props.exportId) {
      buttons.push(
        {
          iconName: 'fa-solid fa-file-circle-check',
          type: ButtonTypeEnum.NormalIconOnly,
          color: ButtonColorsEnum.Common,
          iconPosition: IconPositionEnum.Center,
          onClick: () => this.clickOnValidatePaymentInformation(),
          tooltip: 'Validate Payment Information',
          roleKey: 'PaymentInformationValidation_ButtonRowButton',
        },
        {
          iconName: 'fa-solid fa-envelope-circle-check',
          type: ButtonTypeEnum.NormalIconOnly,
          color: ButtonColorsEnum.Common,
          iconPosition: IconPositionEnum.Center,
          onClick: () => this.clickOnRequestPaymentDetailsReview(),
          tooltip: 'Request Payment Details Review',
          roleKey: 'RequestPaymentDetailsReview_ButtonRowButton',
        }
      );
    }

    return (
      <FigmaButtonRow
        className={'MenuButtonList'}
        buttons={buttons}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        {this.props.showActionButtonRow && this.renderActionButtonRow()}
        <TabOfDataTable
          type={VExportPaymentBaseItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={VExportPaymentService.GetListBySearching}
          convertDBItemsFunction={VExportPaymentService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          itemList={this.state.itemList}
          changeOfItemListFunction={this.changeOfItemListFunction}
          showSearchStrip={true}
          searchParamsType={ExportPaymentSearchParams}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name, email and status...'
          errorCode='PEDPET361'
        />
      </div>
    );
  }
}
